// extracted by mini-css-extract-plugin
export default {"saveForLater":"VNIZl"};